import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function SocialSecurityCenterIcon({ className }: IconProps) {
  return (
    <svg
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2229)">
        <path
          d="M86.8626 84.3852H4.1377C4.1377 81.6444 6.35142 79.4307 9.09223 79.4307H81.8817C84.6225 79.4307 86.8362 81.6444 86.8362 84.3852"
          fill="#00C4B3"
        />
        <path
          d="M4.1377 32.2573H86.8626C86.8626 34.9981 84.6488 37.2119 81.908 37.2119H9.09223C6.35142 37.2119 4.1377 34.9981 4.1377 32.2573Z"
          fill="#00C4B3"
        />
        <path
          d="M51.3106 37.2119H39.7148V79.4045H51.3106V37.2119Z"
          fill="#DFE2E9"
        />
        <path
          d="M23.5869 37.2119H11.9912V79.4045H23.5869V37.2119Z"
          fill="#DFE2E9"
        />
        <path
          d="M78.9824 37.2119H67.4131V79.4045H78.9824V37.2119Z"
          fill="#DFE2E9"
        />
        <path
          d="M51.2851 79.4042H39.6894C38.5562 79.4042 37.6338 78.4818 37.6338 77.3486C37.6338 76.2153 38.5562 75.2666 39.6894 75.2666H51.2851C52.4183 75.2666 53.3407 76.189 53.3407 77.3486C53.3407 78.5081 52.4183 79.4042 51.2851 79.4042Z"
          fill="#DFE2E9"
        />
        <path
          d="M51.2851 41.3495H39.6894C38.5562 41.3495 37.6338 40.4271 37.6338 39.2939C37.6338 38.1607 38.5562 37.2119 39.6894 37.2119H51.2851C52.4183 37.2119 53.3407 38.1343 53.3407 39.2939C53.3407 40.4534 52.4183 41.3495 51.2851 41.3495Z"
          fill="#DFE2E9"
        />
        <path
          d="M23.5869 79.4042H11.9912C10.8579 79.4042 9.93555 78.4818 9.93555 77.3486C9.93555 76.2153 10.8579 75.2666 11.9912 75.2666H23.5869C24.7201 75.2666 25.6425 76.189 25.6425 77.3486C25.6425 78.5081 24.7201 79.4042 23.5869 79.4042Z"
          fill="#DFE2E9"
        />
        <path
          d="M23.5869 41.3495H11.9912C10.8579 41.3495 9.93555 40.4271 9.93555 39.2939C9.93555 38.1607 10.8579 37.2119 11.9912 37.2119H23.5869C24.7201 37.2119 25.6425 38.1343 25.6425 39.2939C25.6425 40.4534 24.7201 41.3495 23.5869 41.3495Z"
          fill="#DFE2E9"
        />
        <path
          d="M79.0088 79.4042H67.4394C66.3062 79.4042 65.3838 78.4818 65.3838 77.3486C65.3838 76.2153 66.3062 75.2666 67.4394 75.2666H79.0088C80.142 75.2666 81.0644 76.189 81.0644 77.3486C81.0644 78.5081 80.142 79.4042 79.0088 79.4042Z"
          fill="#DFE2E9"
        />
        <path
          d="M79.0088 41.3495H67.4394C66.3062 41.3495 65.3838 40.4271 65.3838 39.2939C65.3838 38.1607 66.3062 37.2119 67.4394 37.2119H79.0088C80.142 37.2119 81.0644 38.1343 81.0644 39.2939C81.0644 40.4534 80.142 41.3495 79.0088 41.3495Z"
          fill="#DFE2E9"
        />
        <path
          d="M87.6794 91.0001H3.32059C1.47582 91.0001 0 89.5243 0 87.6795C0 85.8347 1.47582 84.3589 3.32059 84.3589H87.7058C89.5242 84.3589 91.0264 85.8347 91.0264 87.6795C91.0264 89.5243 89.5505 91.0001 87.7058 91.0001"
          fill="#00416B"
        />
        <path
          d="M48.2008 0.816964C46.5669 -0.289899 44.4322 -0.289899 42.7983 0.816964L0.763797 29.2265C-0.632959 30.1489 0.0258883 32.2572 1.73889 32.2572H89.2865C90.9732 32.2572 91.6584 30.1489 90.2616 29.2265L48.2008 0.816964Z"
          fill="#00416B"
        />
        <path
          d="M53.3671 18.2104C53.3671 22.5588 49.862 26.0639 45.5136 26.0639C41.1652 26.0639 37.6602 22.5324 37.6602 18.2104C37.6602 13.8884 41.1652 10.3569 45.5136 10.3569C49.862 10.3569 53.3671 13.8884 53.3671 18.2104Z"
          fill="#FBFCFE"
        />
        <path
          d="M50.4677 18.2104C50.4677 20.9512 48.2539 23.1649 45.5131 23.1649C42.7723 23.1649 40.5586 20.9512 40.5586 18.2104C40.5586 15.4696 42.7723 13.2559 45.5131 13.2559C48.2539 13.2559 50.4677 15.4696 50.4677 18.2104Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2229">
          <rect width="91" height="91" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
